export function serializeBlockContent(content: unknown): string {
  if (typeof content === 'string') return content;
  return content == null ? '' : JSON.stringify(content);
}
